export default "/assets/markers/driver_on.png"